import { render, staticRenderFns } from "./MapaOcorrencias.vue?vue&type=template&id=64166153&"
import script from "./MapaOcorrencias.vue?vue&type=script&lang=js&"
export * from "./MapaOcorrencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports